import { LoginOutput, RefreshInput, RefreshOutput } from '@allocab/allocab-commons-shared-types';
import { differenceInMinutes } from 'date-fns';

import { getConfig } from '../../config';
import { clearTokens, updateTokens } from '../../services/auth/auth';
import { queryClient, queryKeys } from '../../services/datastore';
import { Api } from '../../services/network';

export const getFreshTokens = async (): Promise<string | null> => {
  const tokens = queryClient.getQueryData<LoginOutput>(queryKeys.tokens());

  if (!tokens) {
    return null;
  }

  if (differenceInMinutes(new Date(tokens.expires), Date.now()) < 5) {
    const data = await getPassengerApi().post<RefreshInput, RefreshOutput>(
      '/authentication/v1/token/refresh',
      { accessToken: tokens.accessToken, refreshToken: tokens.refreshToken },
      { skipAuth: true },
    );

    const refreshedTokens = {
      accessToken: data.accessToken,
      refreshToken: tokens.refreshToken,
      issued: data.issued,
      expires: data.expires,
    };

    updateTokens(queryClient, refreshedTokens);

    return refreshedTokens.accessToken;
  }

  return tokens.accessToken;
};

let _passengerApi: Api | null;

export const getPassengerApi = (): Api => {
  const passengerApiUrl = getConfig().passengerApiUrl;

  if (!passengerApiUrl) {
    console.error('passengerApiUrl must be defined');
    throw new Error('passengerApiUrl must be defined');
  }

  if (!_passengerApi) {
    _passengerApi = new Api(passengerApiUrl, getFreshTokens, () => {
      clearTokens(queryClient);
    });
  }
  return _passengerApi;
};
